module.exports = __webpack_public_path__ + "static/media/metacartel__avatar.efff1272.jpg";